// ANCHOR React
import { useState } from 'react';

// ANCHOR Utils
import { tuple } from '@lyon/utils/tuple';

// ANCHOR Models
import { createSelector, createSelectors, createNullaryModel } from 'react-scoped-model';
import { useFormQuestionItemDataID, useFormQuestionItemDataPosition } from '../FormQuestionItemData';

export const UpdateFormQuestionPositionForm = createNullaryModel(() => {
  const questionId = useFormQuestionItemDataID();
  const currentPosition = useFormQuestionItemDataPosition();

  const [position, setPosition] = useState(currentPosition);
  const [loading, setLoading] = useState(false);

  return {
    state: {
      position,
      loading,
      questionId,
      original: currentPosition,
    },
    handler: {
      position: setPosition,
      loading: setLoading,
    },
  };
}, {
  displayName: 'Models.UpdateFormQuestionPositionForm',
});

export const useUpdateFormQuestionPositionFormPosition = createSelectors(
  UpdateFormQuestionPositionForm,
  ({ state, handler }) => tuple(
    state.position,
    handler.position,
    state.original,
  ),
);

export const useUpdateFormQuestionPositionFormLoadingValue = createSelector(
  UpdateFormQuestionPositionForm,
  ({ state }) => state.loading,
);

export const useUpdateFormQuestionPositionFormSubmit = createSelectors(
  UpdateFormQuestionPositionForm,
  ({ state, handler }) => tuple(
    state.position,
    state.questionId,
    handler.loading,
  ),
);
